import { AxiosResponse } from "axios";
import { Result } from "../models/common/resultResponse";
import { KeyValue } from "../models/common";
import { IDamageAreaApi } from "./base/damageAreaApi";
import { api } from "./base";

const baseRoute: string = "DamageArea";

export class DamageAreaApi extends IDamageAreaApi {
	getByDamageArea(): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domain`);
	}
}
